import type { App, DirectiveBinding } from 'vue';
import { Local } from '/@/utils/storage';

/**
 * 根据 roleCode 判断用户是否有权限
 * @param value 角色或角色数组
 * @param exclude 是否排除模式
 * @returns 有权限返回 true
 */
function checkRole(value: string | string[], exclude?: boolean): boolean {
	try {
		const roleCodes = Local.get('roleCode');
		if (!roleCodes || !Array.isArray(roleCodes)) return false;

		if (exclude) {
			// 排除模式：用户角色包含排除列表任一则隐藏，都不包含则显示
			const excludeList = Array.isArray(value) ? value : [value];
			return !excludeList.some(excluded => roleCodes.includes(excluded));
		}

		if (typeof value === 'string') {
			return roleCodes.includes(value);
		}

		if (Array.isArray(value)) {
			return value.some(role => roleCodes.includes(role));
		}

		return false;
	} catch {
		return false;
	}
}

/**
 * 角色权限指令（基于 Local.get('roleCode')）
 * @directive v-role="'sales_admin'" 单个角色，包含则显示
 * @directive v-role="['sales_admin', 'dealer']" 多个角色，满足其一则显示
 * @directive v-role-exclude="['sales', 'dealer_sales']" 排除模式，角色包含排除列表任一则隐藏
 */
export function roleDirective(app: App) {
	// v-role：角色包含则显示
	app.directive('role', {
		mounted(el: HTMLElement, binding: DirectiveBinding<string | string[]>) {
			if (!checkRole(binding.value)) {
				el.parentNode?.removeChild(el);
			}
		},
	});

	// v-role-exclude：角色包含排除列表任一则隐藏，都不包含则显示
	app.directive('role-exclude', {
		mounted(el: HTMLElement, binding: DirectiveBinding<string | string[]>) {
			if (!checkRole(binding.value, true)) {
				el.parentNode?.removeChild(el);
			}
		},
	});
}
